export const decodeContactInfo = (contactInfo) => {
    return {
        address: contactInfo.address,
        city: contactInfo.city,
        country: contactInfo.country,
        geoLocationLat: contactInfo.geo_location_lat,
        geoLocationLong: contactInfo.geo_location_long,
        id: contactInfo.contact_info_id,
        phoneNumber: contactInfo.phone_number,
        postCode: contactInfo.post_code,
        state: contactInfo.state
    };
};
export const encodeContactInfo = (contactInfo) => {
    return {
        address: contactInfo.address,
        city: contactInfo.city,
        contact_info_id: contactInfo.id,
        country: contactInfo.country,
        geo_location_lat: contactInfo.geoLocationLat,
        geo_location_long: contactInfo.geoLocationLong,
        phone_number: contactInfo.phoneNumber,
        post_code: contactInfo.postCode,
        state: contactInfo.state
    };
};
